var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.isAudit === undefined || _vm.row.isAudit<0)?[_vm._v("/")]:[_c('el-tag',{attrs:{"size":"mini","type":_vm.options[_vm.row.isAudit].tagType}},[_vm._v(_vm._s(_vm.options[_vm.row.isAudit].text))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }